import AuthenticationGate from 'components/authentication-gate/authentication-gate.component';
import MainLayout from 'components/layouts/main-layout/main-layout.component';
import UnauthenticatedLayout from 'components/layouts/unauthenticated-layout/unauthenticated-layout.component';
import { usePrunedRoutes } from 'hooks/routes.hooks';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import mainRoutes from './main-routes';
import ResetPassword from './reset-password/reset-password.component';
import Login from './login/login.component';
import { GlobalDrawersProvider } from 'components/drawers/global-drawer/global-drawer.context';
import RouterContextProvider from 'components/router-context/router-context.context';
import VerifyEmail from './verifyemail/verifyemail.component';
import ResetPasswordSubmit from './reset-password-submit/reset-password-submit.component';

const BaseRoute = () => {
  return (
    <GlobalDrawersProvider>
      <RouterContextProvider>
        <Outlet />
      </RouterContextProvider>
    </GlobalDrawersProvider>
  );
};

export const routesObject = [
  {
    element: <BaseRoute />,
    children: [
      {
        element: <AuthenticationGate />,
        children: [
          {
            element: <MainLayout />,
            children: mainRoutes,
          },
        ],
      },
      {
        element: <UnauthenticatedLayout />,
        children: [
          {
            path: '/login',
            element: <Login />,
          },
          {
            path: '/login/requestpasswordreset',
            element: <ResetPassword />,
          },
          {
            path: '/verifyemail',
            element: <VerifyEmail />,
          },
          {
            path: '/resetpassword',
            element: <ResetPasswordSubmit />,
          },
        ],
      },
    ],
  },
];

const AppRoutes2 = () => {
  const router = createBrowserRouter(usePrunedRoutes(routesObject));

  return <RouterProvider router={router} />;
};
export default AppRoutes2;
